export const ENV = process.env.REACT_APP_ENV || process.env.NODE_ENV
export const REACT_APP_URL = process.env.REACT_APP_URL || 'https://mbaseapp.kb-vision.at/'
export const REACT_APP_SITE_URL = process.env.REACT_APP_SITE_URL || 'https://landing.minebase.io/'
export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || '/api'
export const SUMSUB_API_URL = process.env.REACT_APP_SUBSUB_API_URL || 'https://api.sumsub.com' // or https://test-api.sumsub.com for sandbox
export const RECAPTCHA_KEY = process.env.REACT_APP_RECAPTCHA_KEY

export const FREEBAY_SCRIPT_URL =
  ENV === 'development'
    ? 'https://fb-universe.kb-vision.at/oauth/js/api_dev.js'
    : 'https://www.fb-universe.com/oauth/js/api.js'
export const FREEBAY_CLIENT_ID = process.env.REACT_APP_FREEBAY_CLIENT_ID || 'vtripplenine'
export const FREEBAY_CLIENT_SECRET = process.env.REACT_APP_FREEBAY_CLIENT_SECRET

export const KARATBARS_SCRIPT_URL =
  ENV === 'development'
    ? 'https://karatbars.kb-vision.at/oauth/js/api_dev.js'
    : 'https://karatbars.com/oauth/js/api.js'
export const KARATBARS_CLIENT_ID = process.env.REACT_APP_KARATBARS_CLIENT_ID || 'kbvtripplenine'
export const KARATBARS_CLIENT_SECRET = process.env.REACT_APP_KARATBARS_CLIENT_SECRET
